<template>
  <div>
    <el-row class="title-bar">
      <el-col class="btn-group-right">
        <el-radio-group class="mr-r15" size="small" v-model="tableDataType" @change="onRadioBtnChange">
          <el-radio label="device">장비기준</el-radio>
          <el-radio label="policy">정책기준</el-radio>
        </el-radio-group>
        <el-button size="small" type="primary" :disabled="executeBtnDisabled" @click="onClickExecutePolicyButton">정책감사수행</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool"/>
      </el-col>
    </el-row>
    <el-row>
      <el-table-wrapper v-show="tableDataType === 'device'" ref="deviceTable" border :data="deviceTableData" :columns="columns.deviceColumns" :column-default="columnDefault" remote pagination :total="total"
        :show-custom-header="true" :show-search-tool="showSearchTool" @condition-change="loadStore" @cell-click="onCellClick" @selection-change="onSelectionChange" style="width:100%;">
        <template slot-scope="scope" slot="slot">
          <span v-if="scope.column.property === 'policyName'" class="link">{{ scope.row.policyName }}</span>
          <span v-else-if="scope.column.property === 'countCR' || scope.column.property === 'countMJ' || scope.column.property === 'countMN' || scope.column.property === 'countNM'" class="link">
            {{ getTableValueAfterCheckEmpty(scope.row, scope.column, scope.row[scope.column.property]) }}
          </span>
        </template>
        <template #obj-name-slot="scope">
          <span v-if="scope.row.objName" class="link c-pointer" @click="clickObjName(scope.row)">{{scope.row.objName}}</span>
          <span v-else>-</span>
        </template>
      </el-table-wrapper>
      <el-table-wrapper v-show="tableDataType === 'policy'" ref="policyTable" border :data="policyTableData" :columns="columns.policyColumns" :column-default="columnDefault" remote pagination :total="total"
        :show-custom-header="true" :show-search-tool="showSearchTool" @condition-change="loadStore" @cell-click="onCellClick"  @selection-change="onSelectionChange" style="width:100%;">
        <template slot-scope="scope" slot="slot">
          <span v-if="scope.column.property === 'policyCount' || scope.column.property === 'violationCount' || scope.column.property === 'failCount'" class="link">
            {{ getTableValueAfterCheckEmpty(scope.row, scope.column, scope.row[scope.column.property]) }}
          </span>
        </template>
        <template #obj-name-slot="scope">
          <span v-if="scope.row.objName" class="link c-pointer" @click="clickObjName(scope.row)">{{scope.row.objName}}</span>
          <span v-else>-</span>
        </template>
      </el-table-wrapper>
    </el-row>
    <w-policy-detail-info-popup ref="policyDetailInfoPopup" :popup-params="popupParams"/>
    <w-policy-execute-result-popup ref="policyExecuteResultPopup" :popup-params="popupParams"/>
    <w-policy-current-compliance-popup ref="policyCurrentCompliancePopup" :popup-params="popupParams"/>
  </div>
</template>

<script>
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import { mapGetters } from 'vuex';
import { isNil, isEmpty } from 'lodash';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import MsgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';
import WPolicyDetailInfoPopup from './popup/PolicyDetailInfoPopup';
import WPolicyExecuteResultPopup from './popup/PolicyExecuteResultPopup';
import WPolicyCurrentCompliancePopup from './popup/PolicyCurrentCompliancePopup';

const severityLevelList = { countCR: 'CR', countMJ: 'MJ', countMN: 'MN', countNM: 'NM' };

export default {
  name: 'WDevicePolicyViolationView',
  components: {
    WPolicyDetailInfoPopup,
    WPolicyExecuteResultPopup,
    WPolicyCurrentCompliancePopup,
  },
  props: {
    activeTab: {
      type: String,
    },
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      tableDataType: 'device',
      deviceTableData: [],
      policyTableData: [],
      showSearchTool: false,
      executeBtnDisabled: true,
      popupParams: {},
      selectedPolicyList: [],
      total: null,
      columnDefault,
      columns: {
        deviceColumns: [
          { type: 'selection' },
          { prop: 'objName', label: '장비명', scopedSlot: 'obj-name-slot', sortable: true, searchable: true, remoteProp: 'obj_name', headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'ipaddress', label: 'IP', sortable: true, searchable: true, remoteProp: 'ipaddress', headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'objtypeName', label: '장비종류', remoteProp: 'ot.objtype_name', sortable: true, searchable: true, width: 120, formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'objCompanyName', label: '제조사', sortable: true, searchable: true, remoteProp: 'obj_company_name', headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'objProductId', label: '모델명', sortable: true, searchable: true, remoteProp: 'obj_product_id', headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'policyName', label: '정책명', sortable: true, searchable: true, scopedSlot: 'slot', remoteProp: 'policy_descr', headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'ruleCount', label: '룰 개수', width: 100, sortable: true, searchable: false, headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty },
          {
            label: '정책감사 수행결과',
            width: 280,
            sortable: false,
            searchable: false,
            headerAlign: 'center',
            childColumns: [
              { prop: 'countCR', label: '위험', headerAlign: 'center', width: 70, sortable: true, searchable: false, scopedSlot: 'slot' },
              { prop: 'countMJ', label: '경고', headerAlign: 'center', width: 70, sortable: true, searchable: false, scopedSlot: 'slot' },
              { prop: 'countMN', label: '주의', headerAlign: 'center', width: 70, sortable: true, searchable: false, scopedSlot: 'slot' },
              { prop: 'countNM', label: '준수', headerAlign: 'center', width: 70, sortable: true, searchable: false, scopedSlot: 'slot' },
            ] },
          { prop: 'checkDatetime', label: '수행일시', width: 150, sortable: true, searchable: true, searchType: 'date', headerAlign: 'center', formatter: this.convertDatetime },
        ],
        policyColumns: [
          { type: 'selection' },
          { prop: 'policyId', label: '정책명', width: 200, sortable: true, searchable: true, headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'policyDescr', label: '정책설명', sortable: true, searchable: true, headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'ruleCount', label: '룰 개수', width: 100, sortable: true, searchable: false, headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'objCount', label: '대상 장비 수', width: 100, sortable: true, searchable: false, headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty },
          {
            label: '준수/미준수 여부',
            sortable: false,
            searchable: false,
            headerAlign: 'center',
            childColumns: [
              { prop: 'policyCount', label: '준수 장비 수', headerAlign: 'center', width: 110, sortable: true, searchable: false, scopedSlot: 'slot' },
              { prop: 'violationCount', label: '미 준수 장비 수', headerAlign: 'center', width: 110, sortable: true, searchable: false, scopedSlot: 'slot' },
            ] },
          { prop: 'failCount', label: '미수행 장비 수', width: 110, sortable: true, searchable: false, scopedSlot: 'slot', headerAlign: 'center', formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'checkDatetime', label: '수행일시', width: 150, sortable: true, searchable: true, searchType: 'date', headerAlign: 'center', formatter: this.convertDatetime },
        ],
      },
      params: {
        managegroupIds: null,
      },
    };
  },
  computed: {
    ...mapGetters(['selectedObjDefineIds', 'selectedNode', 'selectedObjDefineIdsForPhysical']),
    treeType() {
      return this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
    },
  },
  watch: {
    selectedNode: {
      handler() {
        this.params.managegroupIds = this.selectedNode.childManagegroupIds;
        // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
        if (!isNil(this.$refs.deviceTable)) {
          this.$refs.deviceTable.clearFilter();
        } else {
          this.$nextTick(() => {
            this.$refs.deviceTable.clearFilter();
          });
        }
        this.loadStore();
      },
      immediate: true,
    },
    selectedObjDefineIdsForPhysical() {
      this.loadStore();
    },
    activeTab() {
      this.loadStore();
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    /**
     * 정책위배현황 데이터 로드
     * @author jeee12
     */
    loadStore() {
      if (this.active) {
        if (this.activeTab === this.$options.name) {
          if (this.tableDataType === 'device') {
            const tableParams = this.$refs.deviceTable.getParameter();
            const params = {
              ...this.params,
              ...tableParams,
              treeType: this.treeType,
              managetypeId: this.selectedNode.managetypeId,
              objCompanyId: this.selectedNode.objCompanyId,
            };
            if (!isEmpty(this.selectedObjDefineIdsForPhysical)) {
              params.objCompanyIds = this.selectedObjDefineIdsForPhysical;
            }
            if (!isEmpty(this.selectedObjDefineIds)) {
              params.objDefineIds = this.selectedObjDefineIds;
            }
            netdeviceInfoAPI.getNetdeviceDeviceViolationList(params).then((result) => {
              if (result.data.success === true) {
                this.deviceTableData = result.data.data;
                this.total = result.total;
              }
            });
          } else if (this.tableDataType === 'policy') {
            const tableParams = this.$refs.policyTable.getParameter();
            const params = {
              ...this.params,
              ...tableParams,
              treeType: this.treeType,
              managetypeId: this.selectedNode.managetypeId,
              objCompanyId: this.selectedNode.objCompanyId,
            };
            if (!isEmpty(this.selectedObjDefineIdsForPhysical)) {
              params.objCompanyIds = this.selectedObjDefineIdsForPhysical;
            }
            netdeviceInfoAPI.getNetdevicePolicyViolationList(params).then((result) => {
              if (result.data.success === true) {
                this.policyTableData = result.data.data;
                this.total = result.total;
              }
            });
          }
        }
      }
    },
    /**
     * 장비 / 정책기준 radio button change
     * @author jeee12
     */
    onRadioBtnChange() {
      this.showSearchTool = false;
      this.loadStore();
    },
    /**
     * 테이블 데이터 빈 값 확인
     * @author jeee12
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 테이블 날짜 포맷 설정
     * @author jeee12
     */
    convertDatetime(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value);
    },
    /**
     * 테이블 셀 클릭을 통한 팝업 open
     * @author jeee12
     * @param  {[type]} cell   해당 cell
     * @param  {[type]} column 해당 coulumn
     */
    onCellClick(cell, column) {
      if (column.property === 'policyName') {
        this.popupParams = cell;
        this.$refs.policyDetailInfoPopup.open();
      } else if (column.property === 'countCR' || column.property === 'countMJ' || column.property === 'countMN' || column.property === 'countNM') {
        this.popupParams = cell;
        this.popupParams.severityId = severityLevelList[column.property];
        this.$refs.policyExecuteResultPopup.open();
      } else if (column.property === 'policyCount' || column.property === 'violationCount' || column.property === 'failCount') {
        this.popupParams = { managegroupIds: this.selectedNode.childManagegroupIds, ...cell };
        this.$refs.policyCurrentCompliancePopup.open();
      }
    },
    /**
     * 테이블 selection change 함수, 정책감사수행 기능을 위한 policy 리스트 저장
     * @author jeee12
     * @param  {[type]} selection 선택한 row 정보들
     */
    onSelectionChange(selection) {
      this.executeBtnDisabled = selection.length <= 0;
      this.selectedPolicyList = selection;
    },
    /**
     * 정책감사수행 기능 수행
     * @author jeee12
     */
    onClickExecutePolicyButton() {
      this.$confirm(...MsgUtil.getCustomConfirmData('정책을 수행하시겠습니까?')).then(() => {
        const params = [];
        this.selectedPolicyList.forEach((policy) => {
          const executeParam = { policyId: policy.policyId };
          if (policy.objId) executeParam.objId = policy.objId;
          params.push(executeParam);
        });

        // let count = 0;
        netdeviceInfoAPI.getNetdeviceExecutePolicy(params).then((result) => {
          if (result.data.success === true) {
            this.$notify({
              title: '정책 감사 수행',
              customClass: 'center',
              message: '정책 감사를 수행하였습니다.',
              duration: 2000,
            });
            // TODO: notify에서 진행률 표현 시에 진행률 조회 task 기능 오픈 필요. $taskManager 로 관리하도록 수정 필요
            // const resultHistSeqList = result.data.data;
            // const getProgressRateInterval = setInterval(() => {
            //   netdeviceInfoAPI.getExecuteProgressRate({
            //     histSeqList: resultHistSeqList,
            //   }).then((progressResult) => {
            //     count += 1;
            //     const progressRate = progressResult.data.data;
            //     if (progressRate === 1) {
            //       // TODO: notify에서 진행률 표현 필요
            //       this.$message({
            //         type: 'success',
            //         message: '수행을 완료하였습니다.',
            //       });
            //       this.loadStore();
            //       clearInterval(getProgressRateInterval);
            //     }
            //
            //     if (count > 180) {
            //       clearInterval(getProgressRateInterval);
            //       this.$message({
            //         type: 'error',
            //         message: '시간 초과로 진행률 확인을 실패하였습니다.',
            //       });
            //     }
            //   }).catch(() => {
            //     this.$message({
            //       type: 'error',
            //       message: '진행률 확인을 실패하였습니다.',
            //     });
            //   });
            // }, 1000);
          } else {
            this.$message(MsgUtil.getResultMsgData('수행', '정책 감사', false));
          }
        });
      }).catch(() => {
        this.$message(MsgUtil.getResultMsgData('수행', '정책 감사', false));
      });
    },
    /**
     * 장비명 클릭 시 성능/운영 > 요약 탭으로 이동한다. [애플망고 SK]
     * @author Song
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickObjName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/config/group/netdevice/components/DevicePolicyViolationView.vue